import styled from 'styled-components';
import Colors from '../../constants/Colors';
import { Text, FontWeight } from '../Text';
import Icon from '../Icon';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  min-height: 100vh;
  width: 340px;
  padding-top: 15px;
`;

const Content = styled.div`
  width: 315px;
  `;

const Settings = styled.div`
  left: 0px;
  margin-left: 10px;
  padding-bottom: 35px;
  span{
    line-height: 30px;
    font-weight: ${FontWeight.Bold};
    padding-left: 35px;
    i{
      margin-top: 0px;
    }
  }

 @media screen and (max-width: 1099px) {
  } 
`;

const Logo = styled.img`
  max-width: 400px;
  max-height: 75px;
  padding-left: 30px;
  margin-left: 20px;
  margin-top: 10px;
  cursor: pointer;

  @media screen and (max-width: 768px) {
    max-width: 100%;
    max-height: 75px;
  }
`;

const Title = styled(Text)`
  font-size: 15px;
  padding-left: 55px;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: ${FontWeight.SemiBold};
  color: ${Colors.GRAY[3]};
`;

const List = styled.ul`
  width: 100%;
  min-height: 200px;
  list-style-type: none;
  padding-inline-start: 0px;
  margin-top: 20px;
  a{
    text-decoration: none;
  }

  span{
    margin-left: 1px;
    border-left: 4px solid ${Colors.WHITE};
    border-radius: 4px;
  }

  .active span{
    margin-left: 1px;
    border-left: 4px solid ${Colors.SECONDARY};
    border-radius: 4px;
    background: #fff;
    box-shadow: 7px 5px 16px 4px rgba(177, 175, 175, 0.19);
    color: ${Colors.PRIMARY1};
  }

  .active i{
    background:${Colors.SECONDARY};
  }

`;

const Item = styled(Text)`
  color: ${Colors.GRAY[3]};
  font-weight: ${FontWeight.Bold};
  padding-left: 55px;
  line-height: 50px;
  height: 50px;
  display: block;
  cursor:pointer;
  i{
    //color: ${Colors.PURPLE};
    font-size: 27px;
    margin-right: 20px;
    float: left;
    margin-top: 5px;
    
  }
`;

const SubTitle = styled(Text)`
  font-size: 16px;
  margin-left: 5px;
  color: ${Colors.SECONDARY};
  font-weight: ${FontWeight.Bold};
  opacity: 0.6;
  letter-spacing: 2px;
  margin-bottom: 20px;
  display: block;
`;

export const ElipseIcon = styled(Icon)`
border-radius: 100%;
height: 40px;
width: 40px;
text-align: center;
padding-top: 6px;
background:${Colors.GRAY[7]};

.active{
  background: ${Colors.SECONDARY};
}

`;


export { Container, Logo, Title, List, Item, Settings, SubTitle, Content };
